document.addEventListener(
  "click",
  (e) => {
    const checkoutButton = document.querySelector('button[name="checkout"]');
    if (
      checkoutButton &&
      checkoutButton.contains(e.target) &&
      window.hulkapps != undefined &&
      is_draft_order !== undefined &&
      (ZapietCheckoutEnabled == undefined || ZapietCheckoutEnabled) &&
      is_draft_order
    ) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      hulkappsCheckout();
    }
  },
  true
);
